import React, { useState, useRef } from "react";

const faqs = [
    {
        id: 1,
        header: "What is Lorem Ipsum?",
        text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.`
    },
    {
        id: 2,
        header: "Where does it come from?",
        text: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. `
    },
    {
        id: 3,
        header: "Why do we use it?",
        text: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature,`
    },
    {
        id: 4,
        header: "Where can I get some?",
        text: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.`
    }
];

const AccordionItem = (props) => {
    const contentEl = useRef();
    const { handleToggle, active, faq } = props;
    const { header, id, text } = faq;

    return (
        <div className="rc-accordion-card" style={{ border: "1px solid #ddd", borderRadius: "5px", marginBottom: "10px", overflow: "hidden", borderColor: "white", backgroundColor: "#232D3F" }}>
            <div className="rc-accordion-header" style={{ display: "flex", alignItems: "center", cursor: "pointer", justifyContent: "space-between", backgroundColor: active === id ? "black" : "black", transition: "0.3s" }}>
                <div className={`rc-accordion-toggle p-3 ${active === id ? 'active' : ''}`} onClick={() => handleToggle(id)} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <h5 className="rc-accordion-title" style={{ fontWeight: "500", fontSize: "18px", position: "relative", marginBottom: "0", color: active === id ? "#FFC100" : "white", transition: "0.3s", flex: "1" }}>{header}</h5>
                    <i className={`fa fa-chevron-down rc-accordion-icon`} style={{ color: "#FFC100", transition: "transform 0.3s", transform: active === id ? "rotate(180deg)" : "rotate(0deg)" }}></i>
                </div>
            </div>
            <div ref={contentEl} className={`rc-collapse ${active === id ? 'show' : ''}`} style={{ position: "relative", height: active === id ? "auto" : "0", overflow: "hidden", transition: "height 0.35s ease" }}>
                <div className="rc-accordion-body" style={{ flex: "1 1 auto", minHeight: "1px", padding: "15px" }}>
                    <p className='mb-0' style={{ marginBottom: "0", fontSize: "16px", fontWeight: "400", lineHeight: "24px", color: "white" }}>{text}</p>
                </div>
            </div>
        </div>
    )
}

const Accordion = () => {
    const [active, setActive] = useState(null);

    const handleToggle = (index) => {
        if (active === index) {
            setActive(null);
        } else {
            setActive(index);
        }
    }

    return (
        <div className="container-fluid mt-5 mb-5">
            <div className="row justify-content-center">
                <div className="col-md-8 mt-2">
                    {faqs.map((faq, index) => (
                        <AccordionItem key={index} active={active} handleToggle={handleToggle} faq={faq} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
